export enum ExtendTLSubscriptionExtensionsFormFields {
  ChangeSubscriptionPricingTierModel = 'changeSubscriptionPricingTierModel',
}
